export interface DrugTest {
	drugTestId: number;
	channel: string;
	brand: string;
	vendor: string;
	representativeId: number;
	representativeLogin: string;
	representativeName: string;
	conductedOn: Date;
	providerName: string;
	specimenId: string;
	result: string;
}

/** Matches TLP.Sync.Common.Entities.RepPortal.DrugTestResultEnum. */
export enum DrugTestResultEnum {
	Positive = 1,
	Negative = 2,
}
